/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
      <v-card style="margin:auto;" width="1200" >
    <v-card-title style="background-color:#006699;color:white;"></v-card-title>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <!-- ================== DIALOGO ELIMINAR ========================================== -->
       <v-row justify="center">
          <v-dialog v-model="dialogEliminar" persistent max-width="590">
            <v-card>
              <v-overlay :value="overlay2">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
              <v-card-title class="headline">Eliminar Conta bancária</v-card-title>
              <v-card-text>Deseja continuar com essa operação?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="eliminarContas()">Concordar</v-btn>
                <v-btn color="error" text @click="dialogEliminar=false">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
    <!-- ================================================================================= -->

    <!-- ********************************  DIALOGO ENTRADA   ****************************************** -->
                  <v-dialog
                  v-model="dialogo"
                  persistent
                  max-width="600px"
                >
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">Definição de Feriados</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="12">
                          <template>
                            <v-menu
                            outlined
                            ref="menubi"
                            v-model="menubi"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field

                                v-model="editedItem.dataFeriado"
                                :rules="[v => !!v || 'Campo obrigatorio!']"
                                label="Selecione a data"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              max="2024-12-31"
                              min="1950-01-01"
                              v-model="datebi"
                              @change="saveDatebi"
                            ></v-date-picker>
                          </v-menu>
                          </template>
                          </v-col>
                        </v-row>
                      </v-container>
                      <small><span style="color:red;font-weight:bold;">Info:</span> Defina as datas de feriado do ano lectivo currente.</small>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="red darken-1"
                        text
                        @click="dialogo = false"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        :disabled="!editedItem.dataFeriado.length"
                        text
                        @click="SalvarFeriados()"
                      >
                        Salvar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

    <!-- ******************************************************************************************** -->
    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
      <v-toolbar flat color="white">
        <v-btn @click="showDialogs()" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon>Definir Feriados </v-btn >
          <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Pesquisar Feriados</v-toolbar-title>
          <v-divider class="mx-8" inset vertical></v-divider>
          <div class="flex-grow-1"></div>
          <v-btn  v-if="search"  @click="initialize(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisa"
            single-line
            hide-details
          ></v-text-field>
      </v-toolbar>
        <template>
          <v-data-table :search="search" :headers="headers" :items="feriados">
            <template v-slot:item.mes="{ item }">
                <span>{{utilitarios.getMonthDescription(item.mes)}}</span>
            </template>
           <template v-slot:item.action="{ item }">
                  <v-menu
                    :offset-x="offsetX"
                    :offset-y="offsetY"
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab dark small
                       color="#006699"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>menu</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                       <v-list-item v-if="usuarioRole === 'ROLE_SPG' || usuarioRole === 'SUPER_USER'" @click="showConfirmarEliminacao(item)"><v-icon color="red" >delete</v-icon>Eliminar</v-list-item>
                    </v-list>
                  </v-menu>
              </template>
          </v-data-table>
        </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>
import Swal from 'sweetalert2'
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
export default {
  data: () => ({
    produtos: [],
    progresso: false,
    offsetX: false,
    offsetY: true,
    overlay: false,
    dialogo: false,
    utilitarios:utilitarios,
    menubi: false,
    tab: null,
    overlay2: false,
    objConta: null,
    dialogEliminar: false,
    utilitarios: utilitarios,
    dialog_detalhes: false,
    dados_contaCorrente: [],
    feriados: [],
    dados_contaCorrente_saidas: [],
    search: '',
    headers: [
      {
        text: 'Mês',
        align: 'start',
        sortable: false,
        value: 'mes'
      },
      { text: 'Data de Feriado', value: 'data' },
      { text: 'Anolectivo', value: 'anolectivo' },
      { text: 'Registrado por', value: 'autor' },
      { text: 'Ações', value: 'action' }
    ],
    tabsItems:
    [
      { id: 1, tab: 'Geral' },
      { id: 2, tab: 'Preços' },
      { id: 3, tab: 'Estoque' },
      { id: 3, tab: 'Conta Corrente do Produto' }
    ],
    editedItem:{
       dataFeriado:'',
       mes:'',
       dia:'',
       anolectivo:''
    },
    editedItemDefault:{
       dataFeriado:'',
       mes:'',
       dia:'',
       anolectivo:''
     }
  }),

  computed: {
    usuarioRole () {
      return ls.get('role')
    },
    anolectivo () {
      return ls.get('anolectivo')
    }
  },

  watch: {
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },

  created () {
    this.Initialize()
   },

  methods: {
    async  Initialize () {
      try {
        //   let  payload =""
        this.progresso = true
        this.feriados = await axios
          .get('/feriadosFindAll')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    showDialogs () {
      this.dialogo = true
    },

    async SalvarFeriados () {

      this.overlay = true
      let params = 
      {
           data: this.editedItem.dataFeriado ,
           mes: this.editedItem.mes,
           dia: this.editedItem.dia,
           anolectivo: this.anolectivo,
           autor: ls.get('nomeUsuario')
      }

      try {

           let result = await axios.post('/feriadoInsertOrUpdate',params).then((res)=>res.data)
           console.log(result);
          if(result.affectedRows >= 1 ){
            Swal.fire('Informação','Feriado Definido com sucesso','success')
            this.Initialize()
            this.editedItem = this.editedItemDefault
            this.dialogo = false
          }
        
      } catch (error) {
         Swal.fire('Infromação','Ocorreu um erro ao tentar efectuar a operação','error')
      }finally{
        this.overlay = false
      }
    },


    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataFeriado = datebi
      this.editedItem.mes = utilitarios.ObterMonthByDate(datebi)
      this.editedItem.dia = utilitarios.ObterDayhByDate(datebi)
    },
 

  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}
</style>
